export const CLIENT_ROUTE = '/categories';
export const API_ROUTE = '/api/category';
export const CLIENT_TITLE = 'Ангилал';